import clsx from 'clsx';
import { ReactNode, useRef } from 'react';
import { useEscalateFills } from './fills';
import { INPUT_CLASS, LABEL } from './util';

interface CommentBoxProps {
  badge: ReactNode;
  value: string;
  onChange: (value: string) => void;
}

export function CommentBox({ badge, value, onChange }: CommentBoxProps) {
  const notesRef = useRef<HTMLTextAreaElement>(null);
  const fills = useEscalateFills();

  const autoResize = () => {
    const el = notesRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 100)}px`;
  };

  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex items-center gap-2.5">
        {badge}
        <span className={LABEL}>Add Comment</span>
      </div>
      <div className="pl-6">
        <textarea
          ref={notesRef}
          value={value}
          rows={1}
          placeholder="Add a short description"
          className={clsx('resize-none', INPUT_CLASS, fills.control)}
          style={{ overflow: 'hidden' }}
          onChange={(e) => onChange(e.target.value)}
          onInput={autoResize}
        />
      </div>
    </div>
  );
}
